import { OnlineVideoConference } from "types/graphql-schema";

import { onlineVideoConferenceType } from "@helpers/constants";

export const getMeetingVideoConferenceName = ({
  meeting,
  compact,
}: {
  meeting: {
    videoConferenceType?: OnlineVideoConference | null;
  };
  compact?: boolean;
}) => {
  return meeting.videoConferenceType === onlineVideoConferenceType.google
    ? compact
      ? "Meet"
      : "Google Meet"
    : meeting.videoConferenceType === onlineVideoConferenceType.zoom
      ? "Zoom"
      : meeting.videoConferenceType === onlineVideoConferenceType.teams
        ? compact
          ? "Teams"
          : "Microsoft Teams"
        : meeting.videoConferenceType === onlineVideoConferenceType.whereby
          ? "Whereby"
          : meeting.videoConferenceType === onlineVideoConferenceType.aroundco
            ? "Around"
            : "Video Conference";
};
